import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem, Reveal } from "@/components/shared/Reveal";
import { IdCard, BadgeCheck, HeartPulse, ShieldCheck, Wrench, Clock, ListChecks, ArrowRight } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";

const REQUIREMENTS = [
  { icon: IdCard, title: "Valid License / CDL", copy: "A valid driver's license or applicable CDL class for the assignment." },
  { icon: BadgeCheck, title: "Appropriate Endorsements", copy: "Endorsements required for the equipment or cargo involved." },
  { icon: HeartPulse, title: "Medical Qualification", copy: "Where applicable to the assignment or jurisdiction." },
  { icon: ShieldCheck, title: "Driving Eligibility", copy: "A driving record that meets the assignment's requirements." },
  { icon: Wrench, title: "Equipment Experience", copy: "Relevant experience with the trailer type or vehicle involved." },
  { icon: Clock, title: "HOS Availability", copy: "Where applicable, enough available hours to complete the assignment." },
  { icon: ListChecks, title: "Other Assignment-Specific Requirements", copy: "Some assignments may carry additional requirements of their own." },
];

export const DriverRequirements = () => (
  <section id="requirements" data-testid="driver-requirements-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <SectionHeading
        eyebrow="Qualifications"
        title="Drive With RelayRigs"
        description="Qualification depends on the assignment. Here's what commonly applies:"
        align="center"
        testId="driver-requirements"
      />

      <RevealStagger className="mt-14 grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {REQUIREMENTS.map((r) => (
          <RevealItem key={r.title}>
            <div data-testid={`requirement-${r.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="bg-rr-surface border border-rr-line rounded-2xl p-6 h-full">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-rr-orange border border-rr-line mb-4">
                <r.icon size={18} />
              </div>
              <h3 className="font-heading font-bold text-rr-navy text-sm">{r.title}</h3>
              <p className="text-xs text-rr-muted mt-1.5 leading-relaxed">{r.copy}</p>
            </div>
          </RevealItem>
        ))}
      </RevealStagger>

      <Reveal delay={0.2}>
        <div className="mt-12 text-center">
          <button
            onClick={() => openPreRegister("driver")}
            data-testid="start-preregistration-cta"
            className="inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-8 py-4 rounded-full hover:bg-rr-navy transition-all hover:-translate-y-1"
          >
            Start Pre-Registration <ArrowRight size={18} />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
